<template>
    <div class="ContentBox">
        <div class="commonBox TopsBlack"> <Tops :ishome="false"/></div>
        <el-carousel class="bannerBox"  trigger="click" indicator-position="outside" >
            <el-carousel-item v-for="item in 1" :key="item">
             <img src="@/assets/banner-2.png" />
            </el-carousel-item>
        </el-carousel>
        <!--  -->
         <PathBox  @CurrIds="GetCurrIds" />
        <!--  -->
        <div class="ConetBox commonBox">
          <SuccesCase  :Item="v" v-for="(v,i) in Arrs['row']" @ApplyStatus="ApplyStatus=true" :key="i" @LookInfo="LookInfo"/>
          <!-- <ProTips :tableData="Arrs['row']"  v-if="CurrInt == 2 || CurrInt == 3"/> -->
          <el-pagination
            v-if="Arrs['total']>0"
            :current-page.sync="CurrPage"
            :page-size="10"
            layout="total, prev, pager, next"
            :total="Arrs['total']"
          >
          </el-pagination>
        </div>
        <!--  -->
         <transition name="bounce">
          <ApplyBox v-if="ApplyStatus" :ApplyStatus="ApplyStatus" @CanCle="CanCle"/>
        </transition>
        <Footer />
    </div>
</template>
<script>
import ApplyBox from "@/components/PubBox/ApplyBox.vue";
import Tops from "@/components/PubBox/hearTop.vue";
import Footer from "@/components/PubBox/footer.vue";
import PathBox from "@/components/PubBox/PathBox.vue";
import SuccesCase from "@/components/ListBox/SuccesCase.vue";
import ProTips from "@/components/ListBox/ProTips.vue";
import {GetNewsInfoByCid} from '@/requestPub/api';
export default {
    components:{
        Tops,Footer,PathBox,SuccesCase,ProTips,ApplyBox
    },
    data() {
      return {
        ApplyStatus:false,
        CurrPage: 1,
        MenuAct:'',
        CurrInt:'',
        CurrID:'',
        Arrs:new Object()
      }
    },
    methods:{   
      CanCle(){
        this.ApplyStatus=false;
      },
      LookInfo(n){
        // alert(n)
        // this.$router.push('/ListArtInfo?ids='+n);
      },
      GetCurrIds(n){
        this.CurrInt=n.CurrAct;
        this.CurrID= n.ids;
        this.GetInfo();
      },
      GetInfo(){
         GetNewsInfoByCid({Cid:this.CurrID,PageSize:15,PageIndex:this.CurrPage}).then((e)=>{
          this.Arrs = e.Data;
        })
      },
      GetNavClick(e){
        this.CurrInt = e;
      },
      handleCurrentChange(val) {
        this.CurrPage=val;
        this.GetInfo();
      }
    }
}
</script>
<style lang="scss">

.el-timeline{
  padding: 0;
}
  .bannerBox {
    height: 400px;
    .el-carousel__container {
      height: 100%;
    }
    .el-carousel__indicators--outside {
      position: absolute;
      bottom: 100px;
    }
    .el-carousel__item {
      img,
      .el-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  // ConetBox
  .ConetBox{
    display: block!important;
    p{
      text-indent: 40px;
      text-align: left;
      font-size: 16px;
      font-weight: 400;
      color: #333333;
      line-height: 36px;
    }
    img{
      width: 100%;
    }
  }
</style>